const AXIOS_STATUS_MESSAGE = /^Request failed with status code \d+$/;

/**
 * Sign-in posts to /auth/login. Axios puts "Request failed with status
 * code 401" on error.message and the sentence users should see
 * ("Invalid email or password.") on error.response.data.message.
 */
export function loginFailureMessage(error) {
  const apiMessage = error?.response?.data?.message;
  if (typeof apiMessage === "string" && apiMessage.trim()) {
    return apiMessage.trim();
  }
  const raw = typeof error?.message === "string" ? error.message.trim() : "";
  if (raw && !AXIOS_STATUS_MESSAGE.test(raw)) return raw;
  return "Could not sign in. Try again.";
}
